import React from "react";
import GermanyReqMain from "./GermanyReqMain";
import "./../../UaeAttestation/UaeReq/UaeReq.css";

const GermanyReq = () => {
  return (
    <div className="uaeReqContainer">
      <GermanyReqMain />
    </div>
  );
};

export default GermanyReq;
